import { authenticatedPost, authenticatedGet } from "../../../Services/core";

export const LandlordList = async (request) => {
   return await authenticatedPost(request, process.env.REACT_APP_BASE_URL+'landlords/list');
}

export const LandlordProfile = async (request) => {
   return await authenticatedPost(request, process.env.REACT_APP_BASE_URL+'landlords/view');
}
